import dev from 'config/dev.json';
import { isBusinessUnitsEnabled } from 'config/features';
import local from 'config/local.json';
import prod from 'config/prod.json';
import { Config, EnvSpecificConfig } from 'config/types';
import uat from 'config/uat.json';
import { AUTH0_CALLBACK, OKTA_CALLBACK } from 'constants/routes';

const protocol = window.location.protocol;
const host = window.location.host;

const envSpecificConfig = ((): EnvSpecificConfig => {
  switch (process.env.REACT_APP_BUILD_ENV) {
    case 'dev':
      return dev;
    case 'uat':
      return uat;
    case 'prod':
      return prod;
    default:
      return local;
  }
})();

// Configuration flag to switch between Auth0 and Okta
// Set to 'auth0' to use Auth0, 'okta' to use Okta
const AUTH_PROVIDER = process.env.REACT_APP_AUTH_PROVIDER || 'auth0';

const config: Config = {
  loginUrl: envSpecificConfig.loginUrl,
  signalRUrl: `${envSpecificConfig.apiUrl}/liveUpdateSignalRHub`,
  apiUrl: `${envSpecificConfig.apiUrl}`,
  environment: `${envSpecificConfig.environment}`,
  auth0: {
    domain: envSpecificConfig.auth0Domain,
    clientId: envSpecificConfig.auth0ClientId,
    audience: envSpecificConfig.auth0Audience,
    redirectUri: `${protocol}//${host}${AUTH0_CALLBACK}`,
    scopes: ['openid', 'profile', 'email'],
  },
  okta: {
    authorizeUrl: `${envSpecificConfig.oktaUrl}/oauth2/default/v1/authorize`,
    meUrl: `${envSpecificConfig.oktaUrl}/oauth2/default/v1/userinfo`,
    logoutUrl: `${envSpecificConfig.oktaUrl}/oauth2/default/v1/logout`,
    redirectUri: `${protocol}//${host}${OKTA_CALLBACK}`,
    clientId: envSpecificConfig.oktaClientId,
    scopes: ['openid', 'email'],
  },
  messagesAndFlowsGroups: envSpecificConfig.messagesAndFlowsGroups,
  fxoGroups: envSpecificConfig.fxoGroups,
  adminGroup: envSpecificConfig.adminGroup,
  fxoGroupPrefix: envSpecificConfig.fxoGroupPrefix,
  defaultApplicationId: envSpecificConfig.defaultApplicationId,
  enableBusinessUnits: isBusinessUnitsEnabled,
};

// Helper function to get current auth provider
export const getAuthProvider = (): 'auth0' | 'okta' => {
  return AUTH_PROVIDER as 'auth0' | 'okta';
};

export { isBusinessUnitsEnabled } from 'config/features';

export default config;
